import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CodigoConfeccionItemResultsViewModel } from 'src/app/components/_mantenimiento/registros/codigosconfeccion/codigoconfeccion.types';
import { AlmacenesSolicitudViewModel, FilterRecintosSolicitudCamViewModel } from './solicitud-recinto-cam.types';

@Injectable()
export class SolicitudAlmacenCamService {
    private solicitudAlmacenCamEndpoint = this.baseUrl + 'api/campanias/AlmacenSolicitudCam/';

    constructor(
        private http: HttpClient,
        @Inject('BASE_URL') private baseUrl: string,
    ) {}

    /**
     * Creates an HttpParms object through the values in the parameter.
     * @param payload FilterRecintosSolicitudCamViewModel
     * @returns HttpParams
     */
    private convertModelToHttpParms(payload: FilterRecintosSolicitudCamViewModel): HttpParams {
        let params = new HttpParams();
        let k: keyof FilterRecintosSolicitudCamViewModel;

        for (k in payload) {
            let v = payload[k] || '';
            params = params.append(k, v);
        }

        return params;
    }

    getAlmacenesSolicitudCam(payload: FilterRecintosSolicitudCamViewModel): Observable<CodigoConfeccionItemResultsViewModel> {
        const params = this.convertModelToHttpParms(payload);
        return this.getAlmacenesSolicitudCamPagedByFilter(params);
    }

    private getAlmacenesSolicitudCamPagedByFilter(params: HttpParams): Observable<CodigoConfeccionItemResultsViewModel> {
        return this.http.get<CodigoConfeccionItemResultsViewModel>(this.solicitudAlmacenCamEndpoint + 'PagedByFilter/', { params: params });
    }

    updateAlmacenesSolicitudCam(almacenesSolicitudCam: AlmacenesSolicitudViewModel): Observable<any> {
        return this.http.post<AlmacenesSolicitudViewModel>(this.solicitudAlmacenCamEndpoint + 'Almacenes/', almacenesSolicitudCam);
    }
}
